/*
 * Dharvi by Rachana — lightweight wishlist.
 * Product handles are kept in localStorage on the shopper's device.
 * Any element with [data-dh-wish="<handle>"] toggles that product;
 * [data-dh-wish-count] elements show the number of saved items.
 */
(function () {
  var KEY = 'dh-wishlist';

  function get() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function set(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function paint() {
    var list = get();
    document.querySelectorAll('[data-dh-wish]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-dh-wish')) > -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-on', on);
    });
    document.querySelectorAll('[data-dh-wish-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }

  function toggle(handle) {
    var list = get();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1);
    else list.unshift(handle);
    set(list);
    paint();
    document.dispatchEvent(new CustomEvent('dh:wishlist', { detail: list }));
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('[data-dh-wish]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      toggle(btn.getAttribute('data-dh-wish'));
    },
    true
  );

  window.DharviWishlist = { get: get, toggle: toggle, paint: paint };
  document.addEventListener('DOMContentLoaded', paint);
  document.addEventListener('shopify:section:load', paint);
  window.addEventListener('pageshow', paint);
})();
